import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  root: {
    position: 'relative',
    width: 28,
    height: 28,
    backgroundColor: '#13849E',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
  },
  corner: {
    position: 'absolute',
    top: 0,
    right: 0,
    width: 8,
    height: 8,
    backgroundColor: '#A82A42',
  },
  letter: {
    fontFamily: '"Silkscreen", monospace',
    fontWeight: 700,
    fontSize: 15,
    color: '#0D1214',
    userSelect: 'none',
  },
});

export const LogoIcon = () => {
  const classes = useStyles();

  return (
    <div className={classes.root} aria-hidden="true">
      <span className={classes.corner} />
      <span className={classes.letter}>f</span>
    </div>
  );
};
